<template>
  <div  style="padding-left:60px;">
    <div class="" style="padding:40px 10px;">
      <h3 style="padding-bottom: 20px;margin-bottom:20px;border-bottom: 1px solid silver">获得荣誉</h3>
      <div class="wrap" >
        <div class="item" v-for="item in honorList" :key="item.index">
          <img :src="item.imgsrc" style="width: 100%;height:100%;">
          <p>{{ item.name }}</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutHonor",
  data(){
    return{
      honorList:[
        {id:1,name:'全国爱国主义教育示范基地',imgsrc:'https://zbhk.lnyun.com.cn/www/huanren/images/202311/1724189321090510850.png'},
        // {id:1,name:'国家级抗战纪念设施',imgsrc:'https://zbhk.lnyun.com.cn/www/huanren/images/202311/1724189321556078594.png'},
        {id:1,name:'国家级抗战纪念设施',imgsrc:'https://file.lnyun.com.cn/www/huanren/images/202607/2073237464843415554.jpg'},
        {id:1,name:'全国关心下一代党史国史教育基地',imgsrc:'https://file.lnyun.com.cn/www/huanren/images/202607/2073237180696350722.jpg'},
        {id:1,name:'中国华侨国际文化交流基地',imgsrc:'https://file.lnyun.com.cn/www/huanren/images/202607/2073237179920404481.jpg'},
        {id:1,name:'辽宁省国防教育示范基地',imgsrc:'https://zbhk.lnyun.com.cn/www/huanren/images/202311/1724189321929371650.png'},
        {id:1,name:'辽宁省团员教育培训基地',imgsrc:'https://zbhk.lnyun.com.cn/www/huanren/images/202311/1724189322352996353.png'},
        {id:1,name:'全省消防救援队伍思想政治教育基地',imgsrc:'https://zbhk.lnyun.com.cn/www/huanren/images/202311/1724189381261742082.png'},
        {id:1,name:'少先队校外活动实践基地（省级）',imgsrc:'https://zbhk.lnyun.com.cn/www/huanren/images/202311/1724189381639229441.png'}
      ]
    }
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>
.wrap{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.item {
  margin: 0 10px 40px 0;
  width: calc((100% - 20px) / 3);
  min-width: calc((100% - 20px) / 3);
  max-width: calc((100% - 20px) / 3);
  height: 220px;

}
.item:nth-child(3n) {
  margin-right: 0
}
</style>
